import styled from "styled-components";
import { flip } from "utils";
export function Loader() {
  const Container = styled.div`
    height: 60px;
    width: 60px;
    background-color: ${(props) => props.theme.loader.loader};
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
    animation: ${flip} 1.3s infinite;
  `;
  return <Container className="loader_container" />;
}
